import "./Nbsp.css"

const Nbsp = (props) => <i className="Nbsp"> </i>

Nbsp.displayName = "Nbsp"

export default Nbsp
